/**
 * StockoutProjectionChart
 * Projeção de dias até ruptura por produto.
 */

import React from 'react'
import { AlertTriangle, Loader2 } from 'lucide-react'
import './StockoutProjectionChart.css'

const RISK_COLORS = {
  critical: '#e11d48',
  high: '#f97316',
  medium: '#3b82f6',
  low: '#94a3b8'
};

function StockoutProjectionChart({ items = [], loading = false }) {
  if (loading) {
    return (
      <div className="stockout-projection stockout-projection--loading">
        <Loader2 size={20} className="spinning" />
        <span>Carregando projeção...</span>
      </div>
    );
  }

  if (!items.length) {
    return (
      <div className="stockout-projection stockout-projection--empty">
        <p>Sem dados de projeção de ruptura</p>
      </div>
    );
  }

  const maxDays = Math.max(...items.map((i) => i.daysToStockout || 0), 30);

  return (
    <div className="stockout-projection">
      <div className="stockout-projection-header">
        <h3>
          <AlertTriangle size={16} />
          Projeção de Ruptura
        </h3>
        <span className="stockout-projection-hint">Dias até zerar estoque (consumo 90d)</span>
      </div>
      <div className="stockout-projection-list">
        {items.map((item) => {
          const days = item.daysToStockout;
          const width = days != null ? Math.min(100, (days / maxDays) * 100) : 0;
          const color = RISK_COLORS[item.riskLevel] || RISK_COLORS.low;

          return (
            <div key={item.productId} className="stockout-projection-row">
              <div className="stockout-projection-row-meta">
                <strong title={item.name}>{item.name}</strong>
                <span>{item.sku || '—'} · {item.brand || 'Sem marca'}</span>
              </div>
              <div className="stockout-projection-bar-wrap">
                <div
                  className="stockout-projection-bar"
                  style={{ width: `${width}%`, backgroundColor: color }}
                />
              </div>
              <div className="stockout-projection-days" style={{ color }}>
                {days != null ? `${days}d` : '—'}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default StockoutProjectionChart
